// Suppress noisy third-party console messages in development
if (import.meta.env.DEV) {
  const originalLog = console.log;
  const originalInfo = console.info;
  const suppress = (orig: typeof console.log) => (...args: unknown[]) => {
    const msg = typeof args[0] === 'string' ? args[0] : '';
    if (msg.includes('React DevTools') || msg.includes('react-devtools') || msg.includes('locize.com')) return;
    orig.apply(console, args);
  };
  console.log = suppress(originalLog);
  console.info = suppress(originalInfo);
}

import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import * as Sentry from "@sentry/react";
import { initPostHog } from "./lib/posthog";
import { logger } from "./lib/logger";
import "./i18n";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry error monitoring (production only)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.PROD ? "production" : "development",
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Initialize PostHog analytics (production only)
initPostHog();

// Register service worker for push notifications and API caching
// Skip in Capacitor native — SW not supported in native WebView
if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  // Register new service worker with caching support
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
    .then((registration) => {

      // Check for updates periodically (every 30 minutes)
      setInterval(() => {
        registration.update();
      }, 30 * 60 * 1000);
    })
    .catch((error) => {
      logger.error("main", "Service worker registration failed:", error);
    });
}

createRoot(document.getElementById("root")!).render(<App />);
